var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#c15d00",
    width: "800px",
    height: "800px",
    viewBox: "0 0 46.00 46.00",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#c15d00",
    strokeWidth: 0.00045996000000000003,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_05.Tag",
    "data-name": "05.Tag",
    d: "M44.6,23.775l-22.8,22.8a.854.854,0,0,1-.095.144,1.05,1.05,0,0,1-1.43,0,.919.919,0,0,1-.095-.144L3.425,29.81a.9.9,0,0,1-.144-.095,1.05,1.05,0,0,1,0-1.43.968.968,0,0,1,.144-.095l22.8-22.8A.979.979,0,0,1,27,5h4.056a5.711,5.711,0,0,1,1.67-3.683l.016.018A1.041,1.041,0,0,1,33.5,1a1.109,1.109,0,0,1,1.072,1.143,1.143,1.143,0,0,1-.441.9A3.27,3.27,0,0,0,33.193,5H38a.977.977,0,0,1,.775.395l5.83,5.83A.984.984,0,0,1,45,12V23A.98.98,0,0,1,44.6,23.775ZM34.254,16.666A1.036,1.036,0,0,1,33.5,17a1.108,1.108,0,0,1-1.07-1.143,1.146,1.146,0,0,1,.441-.9,2.9,2.9,0,0,0,.617-.883,2.006,2.006,0,1,0,2.067.681A3.682,3.682,0,0,1,34.254,16.666ZM43,12.381,37.615,7H33.4a2.964,2.964,0,0,0,.725,1.1h0a.98.98,0,0,1,.127.092l.018-.018A5.817,5.817,0,0,1,36,12.428c0,.042-.01.079-.012.12a3.993,3.993,0,1,1-2.168-.53A3.34,3.34,0,0,0,32.868,9.9a1.163,1.163,0,0,1-.129-.092l-.016.018A5.537,5.537,0,0,1,31.17,7H27.377l-22,22L21,44.619l22-22V12.381Zm-28.714,14.9a.977.977,0,0,1,1.381,0l7.049,7.049a.977.977,0,0,1-1.381,1.381l-7.049-7.049A.977.977,0,0,1,14.282,27.285Zm4-4a.977.977,0,0,1,1.381,0l7.048,7.049a.977.977,0,1,1-1.381,1.381l-7.048-7.049A.977.977,0,0,1,18.282,23.285Z",
    transform: "translate(-3 -1)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagSvgrepoCom);
export default __webpack_public_path__ + "static/media/tag-svgrepo-com.ddb09428c2b72e4865ea187c2f851427.svg";
export { ForwardRef as ReactComponent };